module.exports = __webpack_public_path__ + "static/media/0201.222c17f9.png";